<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'
import { useLandingTheme } from '@/composables/useLandingTheme'

withDefaults(
  defineProps<{
    tone?: 'default' | 'landing'
  }>(),
  { tone: 'default' },
)

const { t } = useI18n()
const { isLight, toggle } = useLandingTheme()
</script>

<template>
  <button
    type="button"
    class="grid size-9 place-items-center rounded-full transition"
    :class="
      tone === 'landing'
        ? 'lp-nav hover:bg-black/5 hover:text-[var(--lp-fg)]'
        : 'text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-neutral-300 dark:hover:bg-neutral-700 dark:hover:text-white'
    "
    :aria-label="isLight ? t('landing.themeToDark') : t('landing.themeToLight')"
    @click="toggle"
  >
    <AppIcon :name="isLight ? 'moon' : 'sun'" size="sm" />
  </button>
</template>
